export const environment = {
  production: false,
  uri:''
};


// WEBPACK FOOTER //
// ./src/environments/environment.ts